import { HttpHeaders } from "@angular/common/http";
import {Injectable} from "@angular/core";
import {InterceptorUtil, OCC_USER_ID_ANONYMOUS, USE_CLIENT_TOKEN} from "@spartacus/core";
import {OrderModule} from "@spartacus/order";
import {OccOrderHistoryAdapter} from "@spartacus/order/occ";
import {Order, ORDER_NORMALIZER} from "@spartacus/order/root";
import {Observable} from "rxjs";


@Injectable({
    providedIn: OrderModule
})
export class EbOccOrderHistoryAdapter extends OccOrderHistoryAdapter {
    override load(userId: string, orderId: string): Observable<Order> {
        const url = this.occEndpoints.buildUrl('orderDetail', {
            urlParams: {
                userId,
                orderId
            }
        })

        let headers = new HttpHeaders()
        if (userId === OCC_USER_ID_ANONYMOUS) {
            headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers)
        }

        return this.http.post(url, { headers }).pipe(this.converter.pipeable(ORDER_NORMALIZER))
    }
}
